var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"summary-view"},[_c('strategy-deck',{attrs:{"strategies":_vm.currentVersionStrategies,"type":_vm.type},on:{"strategySelected":_vm.onStrategySelected}},[_vm._v("summary-view Component")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }